// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3412":"28ff7da3","7027":"ff5033b6","8847":"7b672fd0","9484":"0a00071f"}[chunkId] + ".css";
};